import React, { useEffect, useRef, useState } from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import styles from './SectionExpand.scss';

type SectionExpandProps = {
  children: React.ReactNode;
  className?: ClassNameType;
  isOpen: boolean;
};

export const SectionExpand = ({
  children,
  className,
  isOpen,
}: SectionExpandProps) => {
  const [height, setHeight] = useState('0');

  const content = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setHeight(isOpen ? `${content?.current?.scrollHeight}px` : '0');
  }, [isOpen, children]);

  return (
    <div className={cx(styles.component, className, { [styles.expanded]: isOpen })}>
      <div
        aria-hidden={!isOpen}
        className={cx(styles.contentWrapper)}
        style={{ maxHeight: `${height}` }}
        tabIndex={-1}
      >
        <div ref={content} className={cx(styles.content)}>
          {children}
        </div>
      </div>
    </div>
  );
};
